import { useModals } from 'almanac-ui/Modal'
import { useCurrentWorkspace } from 'hooks/useCurrentWorkspace'

import { NewSnippetModal, NewSnippetModalProps } from 'screens/BrandKits/components/NewSnippetModal/NewSnippetModal'
import useResponsiveDesign from 'hooks/useResponsiveDesign'

export type OpenNewSnippetModalProps = Pick<NewSnippetModalProps, 'content' | 'onClose' | 'kinds' | 'onSave'>
export type StackProps = { newStack?: boolean }
export type OpenNewSnippetModalType = (props?: OpenNewSnippetModalProps, stackProps?: StackProps) => void

export const useOpenNewSnippetModal = () => {
  const currentWorkspace = useCurrentWorkspace()
  const { openModal } = useModals()
  const { isMobile } = useResponsiveDesign()

  const openNewSnippetModal: OpenNewSnippetModalType = (
    props?: OpenNewSnippetModalProps,
    stackProps?: { newStack?: boolean },
  ) => {
    if (!currentWorkspace) return
    if (isMobile) {
      // Leave some time for the click to propagation without being the modal open.
      // If this is not done, the modal will open and a snippet type will be selected immediately
      // due to the click propagation.
      setTimeout(() => {
        openModal(NewSnippetModal, props, stackProps)
      }, 20)
      return
    }
    openModal(NewSnippetModal, props, stackProps)
  }

  return openNewSnippetModal
}
